import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import './index.less';

import IbTypography from '../../../../../components/common/IbTypography';
import { SearchChunk, SearchMessageModel } from '../../../../../../gamma-api';
import TextChunk from '../../../../../components/TextChunk';
import MarkdownContent from '../../../../../components/MarkdownContent';
import { getChatMessageTextContent } from '../../../../../utils/messageUtil';

const MAIN_CLASS_NAME = 'assistant-message-view';
const EMPTY_CLASS_NAME = `${MAIN_CLASS_NAME}_empty`;
const MESSAGE_CLASS_NAME = `${MAIN_CLASS_NAME}__message`;
const CONTENT_CLASS_NAME = `${MESSAGE_CLASS_NAME}__content`;

interface IAssistantMessageViewProps {
  message?: SearchMessageModel;
}

const AssistantMessageView: React.FC<IAssistantMessageViewProps> = ({ message }) => {
  const { t } = useTranslation();

  const assistantMessageViewStartRef = useRef<HTMLDivElement>(null);

  const renderChunk = (chunk: SearchChunk, index: number) => (
    <TextChunk
      key={`${message?.message_id}_${index}`}
      chunk_num={index + 1}
      contentId={message?.message_id}
      metadata={chunk.metadata}
      score={chunk.score}
      text={chunk.text}
    />
  );

  const onMessagePropChange = () => {
    assistantMessageViewStartRef.current?.scrollIntoView({ behavior: 'smooth' });
  };
  useEffect(onMessagePropChange, [message]);

  if (!message) {
    return (
      <div className={`${MAIN_CLASS_NAME} ${EMPTY_CLASS_NAME}`}>
        <IbTypography.Paragraph disabled type="secondary">
          {t('Chat: Select a message to view recognized chunks')}
        </IbTypography.Paragraph>
      </div>
    );
  }

  return (
    <div className={MAIN_CLASS_NAME}>
      <div ref={assistantMessageViewStartRef} />
      <div className={MESSAGE_CLASS_NAME}>
        <IbTypography.Paragraph className={CONTENT_CLASS_NAME}>
          <MarkdownContent>{getChatMessageTextContent(message.chat_message)}</MarkdownContent>
        </IbTypography.Paragraph>
      </div>
      {(message.chunks || []).map(renderChunk)}
    </div>
  );
};

export default AssistantMessageView;
